import BaseCheckbox from './Checkbox';

// EXPORT
export const Checkbox = BaseCheckbox;
export type { CheckBoxProps } from './CheckBox.interface';
